export default "__VITE_ASSET__7b3281fb__"